// @flow

import * as React from 'react';
import useRequest from 'hooks/useRequest';
import Config from '@insolus/config';
import ApiArticles from 'stores/api/articles';
import catchApiError from 'utils/catchApiError';
import Articles from '../../components/Articles';
import Loading from 'components/Loading';

import type { Article } from 'stores/api/articles';

const ReportageElement = (): React.Node => {
    const [isFetched, setIsFetched] = React.useState<boolean>(false);
    const [data, setData] = React.useState<Article[]>([]);
    const [error, setError] = React.useState<string | null>(null);

    const fetchReportages = useRequest(limit => ApiArticles.all('reportages', limit));
    const fetchDossiers = useRequest(limit => ApiArticles.all('dossiers', limit));

    React.useEffect(() => {
        const fetch = async () => {
            const elements = Config.get('articles.elements');

            try {
                const reportages = await fetchReportages.execute(elements);
                const dossiers = await fetchDossiers.execute(elements);
                const compare = (a: Article, b: Article): number => {
                    if (a.date === b.date) {
                        return 0;
                    }
                    return a.date < b.date ? 1 : -1;
                };
                setData(reportages.concat(dossiers).sort(compare).slice(0, elements));
            } catch (_error) {
                setError(catchApiError(_error));
            } finally {
                setIsFetched(true);
            }
        };
        fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isFetched) {
        return <Loading />;
    }
    if (error) {
        return error;
    }
    if (data.length === 0) {
        return null;
    }

    return (
        <Articles data={data} />
    );
};

export default ReportageElement;
